var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_backarrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "APP\\u5C55\\u793A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8BE6\\u60C5\\u9875",
    transform: "translate(-16.000000, -55.000000)",
    stroke: "#EEEEEE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9876\\u90E8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD",
    transform: "translate(16.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(6.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.03553391,2.03553391 L10.863961,2.03553391 C11.4162458,2.03553391 11.863961,2.48324916 11.863961,3.03553391 L11.863961,11.863961",
    id: "\\u8DEF\\u5F84",
    transform: "translate(6.949747, 6.949747) rotate(-135.000000) translate(-6.949747, -6.949747) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 6.94974747,
    x2: 18.5010817,
    y2: 6.72290706,
    id: "\\u8DEF\\u5F84-2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackarrow);
export default __webpack_public_path__ + "static/media/icon_backarrow.b3e1585f664f93e0d666c40bb3477e7d.svg";
export { ForwardRef as ReactComponent };